/**
 * Main Application Component — CTI Agent Widget with SAP-based authentication.
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { CXoneProvider } from './contexts/CXoneContext';
import { AgentWidget } from './components/AgentWidget';
import './App.css';

function AppLoading({ message }: { message: string }) {
  return (
    <div className="app-loading">
      <div className="spinner" />
      <p>{message}</p>
    </div>
  );
}

function AppContent() {
  const { isAuthenticated, isLoading } = useAuth();
  const { t } = useTranslation();

  if (isLoading) {
    return <AppLoading message={t('common:status.connecting')} />;
  }

  if (!isAuthenticated) {
    return null;
  }

  return (
    <CXoneProvider>
      <Routes>
        <Route path="/" element={<AgentWidget />} />
      </Routes>
    </CXoneProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
